// import { hongkongManifest } from './../modules/countries/hongkong/hongkong-manifest';
// import { japanManifest } from './../modules/countries/japan/japan-manifest';
// import { singaporeManifest } from './../modules/countries/singapore/singapore-manifest';
// import { newzealandManifest } from './../modules/countries/newzealand/newzealand-manifest';
// import { australiaManifest } from './../modules/countries/australia/australia-manifest';
// import { indiaManifest } from './../modules/countries/india/india-manifest';
import { DynamicComponentManifest } from './dynamic-component-manifest';

//TODO: SOLVE this error: ERROR in Cannot read property ‘loadChildren’ of undefined
// ERROR in app/app.module.ts(53,42): Error during template compile of 'AppModule'
//Function calls are not supported in decorators but 'APACManifest' was called in 'manifestArray'
// 'manifestArray' calls 'APACManifest' at app/dynamic-component-loader/dynamic-component-manifest-array.ts(3,40).

import { APACManifest } from './../modules/countries/apac-manifest';
const apacManifest = new APACManifest();
export const manifestArray: DynamicComponentManifest[] = apacManifest.getAllCountriesManifest();

// export const manifestArray: DynamicComponentManifest[] = [
//   ...hongkongManifest,
//   ...japanManifest,
//   ...singaporeManifest,
//   ...australiaManifest,
//   ...newzealandManifest,
//   ...indiaManifest
// ];
